import { Log, Level, Logger } from 'ng2-logger';
import ApiClient from './alms-api';
import { Notification } from '../components/notification/main';
import Translator from '../core/i18n';
import { ISurveyData } from '../models/action/survey';

const T = Translator.create();
let _apiClient: ApiClient;
const token: any = localStorage.getItem('access_token');
const _logger = Log.create('Survey-Service');

export class SurveyService {
    constructor() {
        _apiClient = new ApiClient();
    }

    public async RequestAddSurveyActivityAsync(params: ISurveyData) {
        let setUrl = 'api/survey/add';

        if(params.activityId) {
            setUrl = 'api/survey/edit';
        }

        return _apiClient.RequestAsync('POST', setUrl, params, token).then((responseData: Response) => {
            return responseData;
        }).then((result: any) => {
            return result;
        }).catch((response) => {
            return response;
        });
    }

    public async RequestGetUpdateSurveyActivity(params: any) {
        return _apiClient
            .RequestAsync('POST', 'api/activity/activitylist', params)
            .then((result: any) => {
                return result;
            })
            .catch(response => {
                return response;
            });
    }

    public async RequestDeleteSurveyActivityAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/survey/delete', params.surveyData, token)
        .then((result: any) => {
            return result;
        })
        .catch(response => {
            return response;
        });
    }

    public async RequestEditSurveyInfoAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/survey/editsurveyinfo', params, token).then((responseData: Response) => {
            return responseData;
        }).then((result: any) => {
            return result;
        }).catch((response) => {
            return response;
        });
    }

    public async RequestResponseSurveyAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/survey/saveresponse', params, token).then((responseData: Response) => {
            return responseData;
        }).then((result: any) => {
            return result;
        }).catch((response) => {
            return response;
        });
    }

    // Get Survey List
    public async RequestGetSurveyListAsync(params: any) {
        return _apiClient
            .RequestAsync(
                'POST',
                'api/survey/my',
                {
                    Take: params.take ? params.take : 20,
                    Skip: params.skip ? params.skip : 0,
                    lastActivityId : params.lastActivityId ? params.lastActivityId : ''
                },
                token
            )
            .then((responseData: Response) => {
                return responseData;
            }).catch((response) => {
                return response;
            });
    }

     // Get Selected Survey
     public async RequestGetSelectedSurveyAsync(values: any) {
        return _apiClient.RequestAsync('POST', 'api/survey/singleactivity', values.params, token)
        .then((result: any) => {
            return result;
        })
        .catch(response => {
            return response;
        });
    }

    // Get Selected General Type Survey
    public async RequestGetGeneralSurveyAsync(values: any) {
        return _apiClient.RequestAsync('POST', 'api/survey/generalsurvey', {SurveyId: values.params}, token)
        .then((result: any) => {
            return result;
        })
        .catch(response => {
            return response;
        });
    }
}

